import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet } from "../utils/api_service";
const initialState = {
  town: [],
};
let URL = endpoints.town;
const townSlice = createSlice({
  name: "town",
  initialState,
  reducers: {
    townSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        town: row,
      };
    },

    resetState: (state = cloneDeep(initialState), action) => {
      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export const { townSuccess, resetState } = townSlice.actions;

export default townSlice.reducer;

export const getTown = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL,
    }).then(({ data, success }) => {
      if (success) {
        const { content } = data.data;
        const row = content.map((townObject, index) => {
          let townData = {
            index: index + 1,
            id: townObject.id === null ? "" : townObject.id,
            name: townObject.name === null ? "" : townObject.name,
            isActive: townObject.isActive === null ? "" : townObject.isActive,
            sortOrder:
              townObject.sortOrder === null ? "" : townObject.sortOrder,
          };
          return townData;
        });
        dispatch(townSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getTownAll = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL + "/get-all",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((townObj, index) => {
          let townData = {
            index: index + 1,
            id: townObj.id === null ? "" : townObj.id,
            name: townObj.name === null ? "" : townObj.name,
            isActive: townObj.isActive === null ? "" : townObj.isActive,
            sortOrder: townObj.sortOrder === null ? "" : townObj.sortOrder,
          };
          return townData;
        });
        dispatch(townSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};
